const HERO_END = 0.17;

export default function VodacomIcon({ scrollProgress = 0 }) {
  // Normalize 0→1 across the hero scroll range
  const t = Math.min(scrollProgress / HERO_END, 1);

  // Ease-in curve so the zoom accelerates as you scroll deeper
  const eased = t * t;

  const scale   = 1 + eased * 2.6;          // 1× → 3.6× zoom
  const opacity = Math.max(1 - t * 1.4, 0); // fades out before the section ends

  return (
    <div className="vodacom-icon-wrap">
      <div className="vodacom-icon-glow-ring" />
      <img
        src="/Vodacom_Icon.svg"
        alt=""
        aria-hidden="true"
        className="vodacom-icon-img"
        draggable={false}
        style={{
          transform: `scale(${scale})`,
          opacity,
          willChange: 'transform, opacity',
        }}
      />
    </div>
  );
}
